import Vue from 'vue'
import {Mutation, Action, VuexModule, getModule, Module} from "vuex-module-decorators";
import store from "@/store/store";
import {CmsApiClient} from "@/_global/api_clients/CmsApiClient";
import {Util} from "@/_global/utils";


// テーマ別商品追加情報を格納する


@Module({
    name: "ThemeItemVariablesStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class ThemeItemVariablesStore extends VuexModule {

    // state
    private _apiResponse: CMS.ThemeItemVariable[] = [];
    private _variableByItemId: { [itemId: number]: CMS.ThemeItemVariable } = {};

    private apiBackup: CMS.ThemeItemVariable[] = [];
    private edited: { [itemId: number]: CMS.ThemeItemVariable } = {};

    // getter
    get all(): CMS.ThemeItemVariable[] {
        return this._apiResponse || [];
    }

    get variableByItemId(): { [p: number]: CMS.ThemeItemVariable } {
        return this._variableByItemId || {};
    }

    get dirty(): boolean {
        return Object.keys(this.edited).length > 0;
    }

    @Action
    public async init(themeId: number) {
        const response: CMS.ThemeItemVariable[] = await CmsApiClient.getThemeItemVariables(themeId);
        this.refresh(response);
    }

    @Action
    private refresh(response: CMS.ThemeItemVariable[]) {
        this.initVals();
        this.setResponse(response);
        for (let i = 0; i < response.length; i++) {
            this.setVariableByItemId(response[i]);
        }
    }

    @Mutation
    private initVals() {
        this._apiResponse = [];
        this._variableByItemId = {};
        this.edited = {};
    }

    @Mutation
    private setResponse(response: CMS.ThemeItemVariable[]) {
        this._apiResponse = response;
        this.apiBackup = Util.deepCopy(this._apiResponse); //復元用にdeep copyでバックアップ
    }

    @Mutation
    private setVariableByItemId(variable: CMS.ThemeItemVariable) {
        Vue.set(this._variableByItemId, variable.item_id, variable);
    }

    @Mutation
    public localAdd(themeItemVariable: CMS.ThemeItemVariable) {
        const itemId: number = themeItemVariable.item_id;

        themeItemVariable.id = Util.getTempId(this.all as any);
        this._apiResponse.push(themeItemVariable);
        Vue.set(this._variableByItemId, itemId, themeItemVariable);
        Vue.set(this.edited, itemId, themeItemVariable);
    }

    @Mutation
    public localEdit(themeItemVariable: CMS.ThemeItemVariable) {
        const itemId: number = themeItemVariable.item_id;

        this._apiResponse = this._apiResponse.map(v => (v.id == themeItemVariable.id) ? themeItemVariable : v);
        Vue.set(this._variableByItemId, itemId, themeItemVariable);
        Vue.set(this.edited, itemId, themeItemVariable);
    }

    @Action
    public async cancelEdit() {
        this.refresh(this.apiBackup);
    }

    @Action
    public async applyEdit() {
        if (!this.dirty)
            return;

        let themeId!: number;
        for (const itemId in this.edited) {
            await CmsApiClient.setThemeItemVariable(this.edited[itemId]);
            themeId = this.edited[itemId].theme_id;
        }

        this.init(themeId);
    }

}

export default getModule(ThemeItemVariablesStore);
